import React, { ReactElement, Component, useEffect, useContext, useMemo, useCallback, useState, Fragment, useRef } from "react";
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import "./operation-record.less";
// import Highlighter from 'react-highlight-words';
import { Row, Col, Input, Button, Table, Pagination, Space, DatePicker, Select } from "antd";
import { FilterDropdownProps } from 'antd/es/table/interface';
import { ColumnProps } from 'antd/es/table';
import { SearchOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { destroy_worker } from "../../worker/http-func";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { RecordsContext, records_type_item } from "../../contexts/records";
import { formatDate, isEffective } from "../../pages/user-management/user-util";
// import DropdownMenuSubscription from "../../components/dropdown-menu-subscription/dropdown-menu-subscription";
// import BreadCrumbs from "../../components/breadcrumb/breadcrumb";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { set_array } from '../../shared-functions';
import { get_db } from '../../http-worker/db-func';
import { TableListContext, table_list_type } from '../../contexts/table-list';
import { worker_fetch } from "../../worker/worker-fetch";

const { Option } = Select;

const OperationRecord: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {

    const [records, set_records]: [records_type_item[], React.Dispatch<React.SetStateAction<records_type_item[]>>] = useContext(RecordsContext),
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        [table_list, set_table_list]: [table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>] = useContext(TableListContext),
        [page_size, set_page_size]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(10),
        [page_number, set_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(1),
        [sort_direction, set_sort_direction]: [string, React.Dispatch<React.SetStateAction<string>>] = useState('desc'),
        [action_filter, set_action_filter]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        [operation_type_filter, set_operation_type_filter]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        [filter_start_time, set_filter_start_time]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
        [filter_end_time, set_filter_end_time]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
        [start_time, set_start_time]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
        [end_time, set_end_time]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
        [keywords_search, set_keywords_search]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        type_list = useMemo(() =>
            user_info.is_globaladmin || user_info.is_datacenteradmin ? ["Rolebinding", "User", "Cluster", "Workspace", "Namespace", "Workspacequota", "Namespacequota"] :
                user_info.is_clusteradmin || user_info.is_clusterowner ? ["Rolebinding", "User", "Workspace", "Namespace", "Workspacequota", "Namespacequota"] :
                    user_info.is_workspaceowner ? ["Rolebinding", "User", "Workspace", "Namespace", "Namespacequota"] : []
            , [user_info.is_globaladmin, user_info.is_datacenteradmin, user_info.is_clusteradmin, user_info.is_clusterowner, user_info.is_workspaceowner]),
            { history } = useMemo(() => props, [props]),

        tzo = (new Date().getTimezoneOffset() / 60) * (-1);

    const table_list_array: React.MutableRefObject<{
        [key: string]: (value: any) => void;
    }> = useRef(set_array(['records'], set_table_list));

    const request_array = useRef([
        { key: 'records', func: table_list_array.current.set_records, data: table_list.records },
    ]);

    // 進入頁面時，先讀取 indexedDB 資料
    useEffect((): void => {
        get_db(request_array.current);
    }, []);

    useEffect(() => () => { destroy_worker() }, []);
    const { formatMessage } = useMemo(() => props.intl, [props]);

    const handleTableChange = useCallback((pagination: any, filters: any, sorter: any) => {
        if (sorter.columnKey && sorter.order) {
            sorter.columnKey === "operation_time" && set_sort_direction(sorter.order === 'ascend' ? 'asc' : 'desc');
        } else {
            set_sort_direction('');
        };

        if (isEffective(filters)) {
            if (Array.isArray(filters.operate)) {
                set_action_filter(filters.operate[0] || '')
            } else {
                set_action_filter('')
            }
            // if (Array.isArray(filters.type)) {
            //     set_operation_type_filter(filters.type[0] || '')
            // } else {
            //     set_operation_type_filter('')
            // }
        }
    }, []);

    useEffect((): void => {
        (async (): Promise<void> => {
            if (datacenter_name && isEffective(operation_type_filter)) {
                const action_param = isEffective(action_filter) ? `&operate=${action_filter}` : '';
                const operation_type_param = isEffective(operation_type_filter) ? `&type=${operation_type_filter.toLocaleLowerCase()}` : '';
                const timeorder_param = isEffective(sort_direction) ? `&timeorder=${sort_direction}` : '';
                const start_time_param = start_time === 0 ? '' : `&begintime=${start_time}`;
                const end_time_param = end_time === 0 ? '' : `&endtime=${end_time}`;
                const keywords_param = isEffective(keywords_search) ? `&deskey=${keywords_search}` : '';

                const res: any = await worker_fetch({
                    url: `/v1/datacenter/${datacenter_name}/operatelog?pageNumber=${page_number}&pageSize=${page_size}${timeorder_param}${action_param}${operation_type_param}${keywords_param}${start_time_param}${end_time_param}`,
                    func: undefined,
                    props: { history, formatMessage },
                    datacenter_name,
                });
                const records_new: records_type_item[] = [];
                if (res && res.data && res.data.items && res.data.items.length > 0) {
                    (res.data.items).map((item: any) => {
                       return records_new.push({
                            id: item.Id,
                            type: item.Type,
                            name: item.Name,
                            operate: item.Operate,
                            datacenter: item.Datacenter,
                            subscription: item.Subscription,
                            username: item.Username,
                            userid: item.Userid,
                            cluster: item.Cluster,
                            workspace: item.Workspace,
                            namespace: item.Namespace,
                            reserve: item.Reserve,
                            old: item.Old,
                            new: item.New,
                            description: item.Description,
                            timestamp: item.Timestamp,
                        })
                    })
                    set_records(records_new)
                } else {
                    set_records([])
                }
            }
        // (async (): Promise<void> => {
        //     if (datacenter_name && isEffective(operation_type_filter)) {
        //         const action_param = isEffective(action_filter) ? `&operate=${action_filter}` : '';
        //         const operation_type_param = isEffective(operation_type_filter) ? `&type=${operation_type_filter.toLocaleLowerCase() }` : '';
        //         const timeorder_param = isEffective(sort_direction) ? `&timeorder=${sort_direction}` : '';
        //         const start_time_param = start_time === 0 ? '' : `&begintime=${start_time}`;
        //         const end_time_param = end_time === 0 ? '' : `&endtime=${end_time}`;
        //         const keywords_param = isEffective(keywords_search) ? `&deskey=${keywords_search}` : '';


        //         const records_res: records_type = (await http_request('records', props, set_records, `/v1/datacenter/${datacenter_name}/operatelog?pageNumber=${page_number}&pageSize=${page_size}${timeorder_param}${action_param}${operation_type_param}${keywords_param}${start_time_param}${end_time_param}`, 0,)) as records_type;

        //         // const records_new: records_type_item[] = records_res?.items as records_type_item[];
        //         const totalCount_new: number = records_res?.totalCount;
        //         // records_res && set_records(records_new);
        //         totalCount_new && set_total(totalCount_new);
        //     }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_records, datacenter_name, page_number, page_size, action_filter, operation_type_filter, sort_direction, start_time, end_time, keywords_search]);

    const getDatePickerProps = useCallback(() => {
        const onStartChange = (value: any) => {
            if (isEffective(value)) {
                const time = new Date(value._d).getTime();
                const newTime: number = Number(time.toString().slice(0, -3));
                set_filter_start_time(newTime);
            } else {
                set_filter_start_time(0);
            }
        }
        const onEndChange = (value: any) => {
            if (isEffective(value)) {
                const time = new Date(value._d).getTime();
                const newTime: number = Number(time.toString().slice(0, -3));
                set_filter_end_time(newTime);
            } else {
                set_filter_end_time(0);
            }
        }

        const handleSearch = (confirm: any) => {
            confirm();
            set_start_time(filter_start_time);
            set_end_time(filter_end_time);
            set_page_number(1);
        }

        return ({
            filterDropdown: ({ confirm }: FilterDropdownProps) => (
                <div style={{ padding: 8 }}>
                    <Space direction="vertical">
                        <div>
                            <DatePicker
                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onChange={onStartChange}
                                placeholder="select start time"
                                style={{ display: 'block' }}
                            />
                            <span style={{ display: 'block', textAlign: 'center' }}>-</span>
                            <DatePicker
                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                format="YYYY-MM-DD HH:mm:ss"
                                onChange={onEndChange}
                                placeholder="select end time"
                                style={{ display: 'block' }}
                            />
                        </div>
                        <Row justify="end" style={{ width: '100%' }}>
                            <Button
                                type="primary"
                                onClick={() => handleSearch(confirm)}
                                icon={<SearchOutlined />}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Search
                            </Button>
                        </Row>
                        {/* <Button onClick={() => handleReset(dataIndex, clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button> */}
                    </Space>
                </div>
            ),
            filterIcon: (filtered: boolean) => <ClockCircleOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        })
    }, [filter_end_time, filter_start_time]);


    const redord_column: ColumnProps<any>[] = [
        {
            title: <Fragment>
                <FormattedMessage id="operation_time" />
                <span> (UTC + {tzo})</span>
            </Fragment>,
            dataIndex: 'timestamp',
            key: 'operation_time',
            defaultSortOrder: 'descend',
            sorter: true,
            render: (time: any) => <div>{time && Number(time) ? formatDate(Number(time)) : "--/--/---- --:--:--"}</div>,
            ...getDatePickerProps()
        },
        {
            title: <FormattedMessage id="operator" />,
            dataIndex: 'username',
            key: 'username',
            // ...getColumnSearchProps('operator')
        },
        {
            title: <FormattedMessage id="cluster" />,
            dataIndex: 'cluster',
            key: 'cluster',
            // ...getColumnSearchProps('cluster')
        },
        {
            title: <FormattedMessage id="action" />,
            dataIndex: 'operate',
            key: 'operate',
            filters: [
                {
                    text: 'add',
                    value: 'add',
                },
                {
                    text: 'update',
                    value: 'update',
                },
                {
                    text: 'delete',
                    value: 'delete',
                },
            ],
            onFilter: (value: any, record: any) => {
                set_action_filter(value)
                return record.operate.indexOf(value) === 0
            },
            filterMultiple: false,
        },
        {
            title: <FormattedMessage id="operation_type" />,
            dataIndex: 'type',
            key: 'type',
            // filters: [
            //     {
            //       text: 'user',
            //       value: 'user',
            //     },
            //     {
            //       text: 'cluster',
            //       value: 'cluster',
            //     },
            //     {
            //       text: 'workspace',
            //       value: 'workspace',
            //     },
            //     {
            //     text: 'namespace',
            //     value: 'namespace',
            //     },
            //     {
            //     text: 'workspacequota',
            //     value: 'workspacequota',
            //     },
            //     {
            //     text: 'namespacequota',
            //     value: 'namespacequota',
            //     },
            //     {
            //     text: 'rolebinding',
            //     value: 'rolebinding',
            //     },
            //   ],
            // onFilter: (value: any, record: any) => {
            //     set_operation_type_filter(value)
            //     return record.Type.indexOf(value) === 0
            // },
            // filterMultiple: false,
        },
        {
            title: <FormattedMessage id="target_name" />,
            dataIndex: 'name',
            key: 'target_name',
            // ...getColumnSearchProps('target_name')
        },
        {
            title: <FormattedMessage id="description" />,
            dataIndex: 'description',
            key: 'description',
            width: '40%',
            // ...getColumnSearchProps('description')
        }
    ];

    const onChange = useCallback(
        (pageNumber: number) => {
            set_page_number(pageNumber)
        }, []
    ),

        onShowSizeChange = useCallback(
            (_current: number, pageSize: number) => {
                set_page_size(pageSize);
            }, [],
        );

    useEffect(() => {
        set_operation_type_filter(sessionStorage.getItem("records_type") || type_list[0]);
    }, [type_list])

    return (
        <div className="px-20 mt-20">
            <div className="w-100">
                <div>
                    <span className="card_title management-label-line font-size-16">{formatMessage({ id: 'operation_records' })}</span>
                </div>
                <div className="management-select-area w-100 position-relative z-index-999">
                    <div className="text-right position-absolute font-w-6 z-index-999 font-14" style={{ right: '10px', top: "6px" }}>
                        <FormattedMessage id="operation_records" />:
                        <span className="px-6">{records?.length}</span>
                    </div>
                    <Row gutter={12}>
                        {/* <Col sm={4}>
                            <DropdownMenuSubscription />
                        </Col> */}
                        <Col sm={4}>
                            <div className="font-14"><FormattedMessage id="type" />:</div>
                            {type_list && type_list.length > 0 && (
                                <Select
                                    style={{ height: '40px' }}
                                    className="w-100 pl-20"
                                    showSearch
                                    optionFilterProp="children"
                                    value={operation_type_filter}
                                    onChange={(event: string) => {
                                        set_operation_type_filter(event);
                                        sessionStorage.setItem("records_type", event);
                                        set_page_number(1);
                                    }}
                                >
                                    {Array.isArray(type_list) &&
                                        type_list.map((item_name: string) => (
                                            <Option key={item_name} value={item_name}>
                                                {item_name}
                                            </Option>
                                        ))}
                                </Select>
                            )}
                        </Col>
                        <Col sm={20}>
                            <Input
                                className={"mt-24 box_rounded input_no_border search_input_height"}
                                size="large"
                                style={{ height: '38px' }}
                                allowClear={true}
                                placeholder={formatMessage({
                                    id: "please_input_keywords",
                                })}
                                prefix={<SearchOutlined />}
                                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.keyCode === 13) event.preventDefault();
                                }}
                                onChange={(e) => {
                                    set_keywords_search(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="mt-20">
                    <Col sm={24} className="management-table w-100">
                        <Table
                            size="small"
                            columns={redord_column}
                            dataSource={records}
                            pagination={false}
                            onChange={handleTableChange}
                        />
                    </Col>
                    <Col sm={24} className="text-right mt-20">
                        <Pagination
                            size="small"
                            showQuickJumper={false}
                            showSizeChanger
                            defaultCurrent={page_number}
                            defaultPageSize={page_size}
                            current={page_number}
                            total={records?.length}
                            pageSize={page_size}
                            onChange={onChange}
                            showTotal={(e) => { return <FormattedMessage id="total_items" values={{ value: `${e}` }} /> }}
                            onShowSizeChange={onShowSizeChange}
                        />
                    </Col>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(OperationRecord);